// Feature-flag keys the dashboard branches on, outside the per-integration
// tables in integrationFlags.ts. Mirror of the backend FEATURE_FLAG_KEYS
// (apps/backend/src/modules/feature-flag/feature-flag-keys.ts) — keep in sync.

/**
 * Marketing & ads (pixels, GTM container, product feed, Meta Conversions API).
 * OFF hides the settings section here AND is enforced by the backend: writes
 * are rejected, the storefront is served no pixels, the feed comes back empty
 * and server-side purchase reporting stops.
 */
export const MARKETING_ADS_FLAG = "MARKETING_ADS";

/**
 * The Developer surface — the Google Tag Manager container, and nothing else.
 *
 * Separate from MARKETING_ADS because a container is not a tracking id: it runs
 * whatever JavaScript the seller configured in it, on every storefront page
 * including checkout.
 *
 * It gates the SURFACE, not access. A store that already has a container keeps
 * the screen that edits it whatever this flag says — an orphaned live container
 * with nowhere to remove it is worse than the surface being visible. The panel
 * reads the server's own status rather than deciding from this flag alone.
 */
export const STOREFRONT_DEVELOPER_FLAG = "STOREFRONT_DEVELOPER";
